import React, { useContext } from 'react';

export interface SsrContextValue {
  isSsr: boolean;
  context: { notFound?: boolean };
}

/**
 * Context for SSR: server reads it after render to handle redirects and 404.
 * Server provides { isSsr: true, context: mutableObject }; client provides { isSsr: false, context: {} }.
 * Only use isSsr for early returns or setting context (e.g. context.notFound). Do not use isSsr
 * to conditionally render different markup—that causes hydration mismatch; use useHasMounted() for client-only UI.
 */
export const SsrContext = React.createContext<SsrContextValue>({
  isSsr: false,
  context: {},
});

export function useSsrContext() {
  return useContext(SsrContext);
}
